import React, { useEffect, useState } from "react"
import useBigScreen from "@/hooks/bigScreen"
import useNavigateLink from "@/hooks/useNavigateLink"
import getCountry from '@/utils/getCountry.js'
import { buy_link } from '@/scripts/constant.js'
import NormalMenu from './NormalMenu.js'
import MobileMenu from './MobileMenu.js'
import { useIntl } from "react-intl"
import {
  menu_Air2,
  menu_Air2Pro,
  menu_Air2Ultra,
  menu_BeamPro,
  menu_Eye,
  menu_Hub,
  menu_One,
  menu_OnePro
}from '@/images/home/index'

const NewHeader = ({ menuBlack,dontfixed,ifShowLocalNav,cusBackgroundColor, cusBackdropFilter, headerTextBlack }) => {
    const navigateLink = useNavigateLink
    const intl = useIntl()
    const bigScreen = useBigScreen(1000)
    const region = getCountry()
    const shopUrl = buy_link[region]['shop']
    const [ifSubMenuShow, setIfSubMenuShow] = useState(false)

    const guidesList = [
        {
          id: 1,
          key: "projectaura",
          title: 'Project Aura 🕶',
          link: region == 'base' ? "/aura" : `/${region}/aura`,
        },
        {
          id: 2,
          key: "products",
          title: intl.formatMessage({ id: "menu.products"}),
          link: ""
        },
        // {
        //   id: 3,
        //   key: "wheretobuy",
        //   title: 'Where to Buy',
        //   link: ""
        // },
        {
          id: 4,
          key: "support",
          title: intl.formatMessage({ id: "menu.support"}),
          link: "/support"
    }]

    const categoriesList = [{
    id: 1,
    key: "mostPopular",
    title: intl.formatMessage({ id: "categories_name1" })
    }, {
    id: 2,
    key: "arGlasses",
    title: intl.formatMessage({ id: "categories_name2" })
    }, {
    id: 3,
    key: "beamPro",
    title: 'Beam Pro'
    }, {
    id: 4,
    key: "accessories",
    title: intl.formatMessage({ id: "categories_name3" })
    }]

    const mostPopular_base = [
      {
        id: 1,
        title: 'Eye',
        link: "/eye/",
        desc: "categories_pros_eye_desc", 
        img: menu_Eye
      },
      {
        id: 2,
        title: 'One Pro',
        link: "/one-pro",
        desc: "categories_pros_onepro_desc",
        img: menu_OnePro
      },
      {
        id: 3,
        title: 'One',
        link: "/one",
        desc: "categories_pros_one_desc",
        img: menu_One
      },
      {
        id: 4,
        title: 'Beam Pro',
        link: "/beampro",
        desc: "categories_pros_beampro_desc",
        img: menu_BeamPro
      },
      {
        id: 5,
        title: 'Air 2 Ultra',
        link: "/air2ultra",
        desc: "categories_pros_air2ultra_desc",
        img: menu_Air2Ultra
      }
    ]

    const arGlasses_base = [
      {
        id: 1,
        title: 'One Pro',
        link: "/one-pro",
        desc: "categories_pros_onepro_desc",
        img: menu_OnePro
      },
      {
        id: 2,
        title: 'One',
        link: "/one",
        desc: "categories_pros_one_desc",
        img: menu_One
      },
      {
        id: 3,
        title: 'Air 2 Ultra',
        link: "/air2ultra",
        desc: "categories_pros_air2ultra_desc",
        img: menu_Air2Ultra
      },
      {
        id: 4,
        title: 'Air 2 Pro',
        link: "/air2",
        desc: "categories_pros_air2pro_desc",
        img: menu_Air2Pro
      },
      {
        id: 5,
        title: 'Air 2',
        link: "/air2",
        desc: "categories_pros_air2_desc",
        img: menu_Air2
      }
    ]

    const productsAll = {
        "mostPopular": mostPopular_base,
        "arGlasses": arGlasses_base,
        "beamPro": [
          {
            id: 4,
            title: 'Beam Pro',
            link: "/beampro",
            desc: "categories_pros_beampro_desc",
            img: menu_BeamPro
          },
        ],
        "accessories": [
          {
            id: 1,
            title: 'Eye',
            link: "/eye/",
            desc: "categories_pros_eye_desc", 
            img: menu_Eye
          },
          {
            id: 2,
            title: 'Hub',
            link: buy_link[region]["hub"].shop,
            desc: "homenew_hub_desc", 
            img: menu_Hub
          }
        ],
    }

    useEffect(() => {
        const cssVariables = {
            "--menu-color": headerTextBlack || ifSubMenuShow ? "#000" : "#fff",
            "--menu-checkip-textColor": menuBlack ? "#333" : "#fff",
            "--menu-checkip-btnColor": menuBlack ? "rgba(0,0,0,0.8)" : "rgba(255, 255, 255, 0.80)",
            "--menu-checkip-btnHoverColor": menuBlack ? "rgba(255, 255, 255, 0.80)" : "rgba(0,0,0,0.8)",
            "--menu-checkip-background": menuBlack ? "rgba(233, 233, 233, 0.50)" : "rgba(102, 102, 102, 0.50)",
            "--menu-checkip-boderColor": menuBlack ? "rgba(0, 0, 0, 0.10)" : "rgba(255, 255, 255, 0.20)"
        }

        const root = document.documentElement;

        for (const [variable, value] of Object.entries(cssVariables)) {
            root.style.setProperty(variable, value);
        }

    }, [menuBlack, ifSubMenuShow, headerTextBlack])

    const getLinkUrl = (link) => {
        const url = navigateLink(link)
        return url
    }

    return <>
        {bigScreen ? 
            <NormalMenu
              guidesList={guidesList}
              categoriesList={categoriesList} 
              productsAll={productsAll} 
              shopUrl={shopUrl} 
              getLinkUrl={getLinkUrl} 
              setIfSubMenuShow={setIfSubMenuShow} 
              ifSubMenuShow={ifSubMenuShow} 
              dontfixed={dontfixed} 
              ifShowLocalNav={ifShowLocalNav} 
              cusBackgroundColor={cusBackgroundColor}
              cusBackdropFilter={cusBackdropFilter}
              menuBlack={menuBlack}
              headerTextBlack={headerTextBlack} />
            :
            <MobileMenu 
              guidesList={guidesList} 
              categoriesList={categoriesList} 
              productsAll={productsAll} 
              setIfSubMenuShow={setIfSubMenuShow} 
              ifSubMenuShow={ifSubMenuShow} 
              getLinkUrl={getLinkUrl} 
              shopUrl={shopUrl} 
              dontfixed={dontfixed} 
              ifShowLocalNav={ifShowLocalNav} 
              cusBackgroundColor={cusBackgroundColor}
              cusBackdropFilter={cusBackdropFilter}
              menuBlack={menuBlack}
              headerTextBlack={headerTextBlack} />
        }

    </>
}

export default NewHeader
